import useAxios from "src/core/shared/hooks/useAxios";
import {
  EndpointConfig,
  UseApiRequest,
  RequestConfig
} from "src/core/shared/api/config.api";

export enum OrderImportRequestName {
  LIST_ORDER_IMPORT_SETTINGS = "LIST_ORDER_IMPORT_SETTINGS",
  EXPORT_ORDER_IMPORT_ERRORS = "EXPORT_ORDER_IMPORT_ERRORS"
}

type OrderImportEndpointConfig = {
  [ OrderImportRequestName.LIST_ORDER_IMPORT_SETTINGS ]: EndpointConfig<null, IOrderImportSetting[]>;
  [ OrderImportRequestName.EXPORT_ORDER_IMPORT_ERRORS ]: EndpointConfig<{ processJobId: number }, { message: string }>;
};

const basePath = "order-import";

const requests: RequestConfig<OrderImportEndpointConfig> = {
  [ OrderImportRequestName.LIST_ORDER_IMPORT_SETTINGS ]: data => ({
    url: `${process.env.REACT_APP_API_URL}/${basePath}/settings/all`,
    method: "GET",
    data
  }),
  [ OrderImportRequestName.EXPORT_ORDER_IMPORT_ERRORS ]: params => ({
    url: `${process.env.REACT_APP_API_URL}/${basePath}/process-jobs/${params.processJobId}/export`,
    method: "GET",
    params
  })
};

export const useOrderImportApi: UseApiRequest<OrderImportEndpointConfig> = name => useAxios(requests[ name ], name);

export enum OrderImportType {
  Standard = "orders",
  Pick = "order-picks",
  Prediction = "order-predictions",
  Invoice = "order-invoices",
  Status = "order-statuses"
}

export interface IOrderImportSetting {
  id: number;
  name: string;
  type: OrderImportType;
  description: string;
  s3Path: string;
  options: OrderImportSettingOptions;
  fileType: OrderImportFileType;
}

export enum OrderImportFileType {
  CSV = "CSV",
  XLSX = "XLSX",
  XML = "XML"
}

// Note that the following interface is not inclusive if all the options possible.
// It is only includes the options that are used in the UI.
export interface OrderImportSettingOptions {
  allowManual?: boolean;
}
